import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import OptimizedImage from './OptimizedImage';
import GenderIcon from '../common/GenderIcon';

const { FiX, FiExternalLink, FiChevronRight } = FiIcons;

// ✅ 移到組件外部獨立文件
const QuickPreviewModal = React.memo(({ previewPet, onClose, onNavigate, translatePetType, t }) => {
  if (!previewPet) return null;

  return (
    <div
      className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[9999] flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full flex flex-col max-h-[90vh]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative bg-gradient-to-br from-blue-500 via-purple-600 to-indigo-700 p-6 flex-shrink-0 rounded-t-2xl">
          <button onClick={onClose} className="absolute top-4 right-4 p-2 bg-white/20 backdrop-blur-sm rounded-full hover:bg-white/30 text-white z-10">
            <SafeIcon icon={FiX} className="h-5 w-5" />
          </button>
          <div className="flex items-center space-x-6 text-white">
            <OptimizedImage
              src={previewPet.photo_url}
              alt={previewPet.name}
              className="w-24 h-24 rounded-full object-cover border-4 border-white shadow-xl"
              fallbackContent={
                <div className="w-24 h-24 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center text-white text-3xl font-bold border-4 border-white">
                  {previewPet.name ? previewPet.name.charAt(0).toUpperCase() : '?'}
                </div>
              }
            />
            <div className="flex-1 min-w-0">
              <h2 className="text-3xl font-bold mb-2 truncate">{previewPet.name || t('dashboard.unnamedPet')}</h2>
              <div className="flex flex-wrap items-center gap-4 text-lg opacity-90">
                <span className="capitalize font-semibold">{translatePetType(previewPet.type)}</span>
                {previewPet.breed && <><span>•</span><span>{previewPet.breed}</span></>}
                {previewPet._computed?.age && <><span>•</span><span>{previewPet._computed.age}</span></>}
              </div>
            </div>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto p-6 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-blue-50 p-4 rounded-xl">
              <h3 className="font-bold text-blue-900 mb-2">{t('dashboard.nextFeeding')}</h3>
              <p>{previewPet._computed?.nextFeeding || t('dashboard.notSet')}</p>
            </div>
            <div className="bg-purple-50 p-4 rounded-xl">
              <h3 className="font-bold text-purple-900 mb-2">{t('dashboard.nextMedication')}</h3>
              <p>{previewPet._computed?.nextMedication || t('dashboard.notSet')}</p>
            </div>
            <div className="bg-orange-50 p-4 rounded-xl">
              <h3 className="font-bold text-orange-900 mb-2">{t('dashboard.location')}</h3>
              <p>{previewPet.current_location || t('dashboard.home')}</p>
            </div>
            <div className="bg-green-50 p-4 rounded-xl">
              <h3 className="font-bold text-green-900 mb-2">{t('dashboard.nextVetVisit')}</h3>
              <p>{previewPet.next_vaccine_date || t('dashboard.notSet')}</p>
            </div>
          </div>
        </div>

        <div className="p-6 bg-gray-50 border-t border-gray-200 flex-shrink-0 rounded-b-2xl">
          <button
            onClick={() => onNavigate(previewPet.id)}
            className="w-full flex items-center justify-center space-x-3 px-6 py-4 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-xl hover:from-blue-700 hover:to-indigo-700 transition-all transform hover:scale-105 shadow-lg group"
          >
            <SafeIcon icon={FiExternalLink} className="h-5 w-5" />
            <span className="font-semibold">{t('dashboard.viewFullDetails')}</span>
            <SafeIcon icon={FiChevronRight} className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>
    </div>
  );
});

export default QuickPreviewModal;